/* ==========================================================================
   VERY VAQUERO — THEME JS
   Small, dependency-free modules. No jQuery. Everything is progressive:
   the page works with JS disabled, these only add behaviour.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ *
   * Focus trap — shared by drawers and modals (WCAG 2.4.3)
   * ------------------------------------------------------------------ */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function trapFocus(container, onEscape) {
    function onKey(e) {
      if (e.key === 'Escape') { onEscape(); return; }
      if (e.key !== 'Tab') return;
      var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* ------------------------------------------------------------------ *
   * Drawers — mobile nav and cart
   * ------------------------------------------------------------------ */
  var Drawer = {
    open: null,
    release: null,
    lastFocus: null,

    show: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      this.hide(true);
      this.lastFocus = document.activeElement;
      el.classList.add('is-open');
      el.removeAttribute('inert');
      el.setAttribute('aria-hidden', 'false');
      var overlay = $('[data-vv-overlay]');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('vv-locked');
      this.open = el;
      document.dispatchEvent(new CustomEvent('vv:drawer:open', { detail: { id: id } }));
      this.release = trapFocus(el, function () { Drawer.hide(); });
      var focusTarget = $('[data-vv-autofocus]', el) || $(FOCUSABLE, el);
      if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 60);
    },

    hide: function (silent) {
      if (!this.open) return;
      this.open.classList.remove('is-open');
      this.open.setAttribute('aria-hidden', 'true');
      var overlay = $('[data-vv-overlay]');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.body.classList.remove('vv-locked');
      if (this.release) { this.release(); this.release = null; }
      this.open = null;

      /* El aviso va ANTES de devolver el foco, y ese orden no es cosmético.
         Quien abre el carrito desde la barra de compra deja el foco en un
         botón que Layers escondió al abrirse el cajón; si se le devuelve el
         foco mientras la barra sigue oculta, focus() no hace nada —un
         elemento con visibility: hidden no es enfocable— y el teclado acaba
         en el <body>, es decir, arriba del todo de una ficha de 3.400 px.
         Avisando primero, Layers ya ha devuelto la barra cuando llega el
         focus() y el foco vuelve exactamente al botón que lo tenía. */
      document.dispatchEvent(new CustomEvent('vv:drawer:close'));

      /* Y si el que lo tenía ya no está —se cerró una barra, se repintó el
         carrito— hay que atrapar el foco antes que dejarlo huérfano en el
         <body>. No se adivina si el elemento es enfocable: se intenta y se
         comprueba. Cualquier heurística de visibilidad falla en algún caso
         (offsetParent es null en todo lo que sea position: fixed, y estas
         barras lo son); activeElement no falla en ninguno. */
      if (!silent) {
        var previo = this.lastFocus;
        if (previo && document.contains(previo)) previo.focus();
        if (document.activeElement !== previo) {
          var alterno = $('[data-vv-drawer-open]');
          if (alterno) alterno.focus();
        }
      }
      this.lastFocus = null;
    }
  };
  window.VVDrawer = Drawer;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-vv-drawer-open]');
    if (openBtn) { e.preventDefault(); Drawer.show(openBtn.getAttribute('data-vv-drawer-open')); return; }
    if (e.target.closest('[data-vv-drawer-close]') || e.target.closest('[data-vv-overlay]')) {
      e.preventDefault(); Drawer.hide();
    }
  });

  /* ------------------------------------------------------------------ *
   * Accordions — mobile nav, PDP detail panels, filters
   * ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-vv-accordion]');
    if (!trigger) return;
    e.preventDefault();
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.classList.toggle('is-open', !isOpen);
  });

  /* ------------------------------------------------------------------ *
   * Mega menu — hover on pointer devices, click/keyboard everywhere.
   * Menus must be operable without a mouse.
   * ------------------------------------------------------------------ */
  $$('[data-vv-mega-trigger]').forEach(function (trigger) {
    var item = trigger.closest('.vv-nav__item');
    var mega = item && $('.vv-mega', item);
    if (!mega) return;

    trigger.addEventListener('click', function (e) {
      // On touch, the first tap opens the panel instead of following the link.
      if (window.matchMedia('(hover: none)').matches) {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        if (!isOpen) { e.preventDefault(); }
        $$('[data-vv-mega-trigger]').forEach(function (t) {
          if (t !== trigger) { t.setAttribute('aria-expanded', 'false'); var m = t.closest('.vv-nav__item'); if (m) { var p = $('.vv-mega', m); if (p) p.classList.remove('is-open'); } }
        });
        trigger.setAttribute('aria-expanded', String(!isOpen));
        mega.classList.toggle('is-open', !isOpen);
      }
    });

    item.addEventListener('mouseenter', function () { trigger.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', function () { trigger.setAttribute('aria-expanded', 'false'); mega.classList.remove('is-open'); });

    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { trigger.setAttribute('aria-expanded', 'false'); mega.classList.remove('is-open'); trigger.focus(); }
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) { trigger.setAttribute('aria-expanded', 'false'); mega.classList.remove('is-open'); }
    });
  });

  /* ------------------------------------------------------------------ *
   * Header — shadow-free sticky that hides on scroll down, shows on up.
   * ------------------------------------------------------------------ */
  (function () {
    var header = $('[data-vv-header]');
    if (!header) return;
    var last = 0, ticking = false;
    var threshold = 90;

    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 8);
      if (y > threshold && y > last && !Drawer.open) header.classList.add('is-hidden');
      else header.classList.remove('is-hidden');
      last = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  /* ------------------------------------------------------------------ *
   * «Leer más» de la descripción de categoría.
   *
   * En el teléfono la descripción se recorta a dos líneas por CSS. El botón
   * sólo se añade si el texto DE VERDAD sobra: sin esto aparecería un «leer
   * más» que no despliega nada en las categorías de una línea. Y sólo en
   * móvil, porque en escritorio el recorte no se aplica.
   * ------------------------------------------------------------------ */
  (function () {
    var caja = $('[data-vv-clamp]');
    if (!caja) return;
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;
    if (caja.scrollHeight <= caja.clientHeight + 2) return;

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'vv-cat-open__mas';
    b.textContent = 'Leer más';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var abierto = caja.classList.toggle('is-open');
      b.textContent = abierto ? 'Leer menos' : 'Leer más';
      b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
    caja.parentNode.insertBefore(b, caja.nextSibling);
  })();

  /* ------------------------------------------------------------------ *
   * Scroll reveal — one subtle entrance, once, never blocking.
   * ------------------------------------------------------------------ */
  (function () {
    /* Lo que llega DESPUÉS también se revela. Las tarjetas de «Completa el
       look», las de «va con esto» y las del cajón del carrito se insertan
       por fetch cuando la página ya arrancó, y venían con .vv-reveal a
       opacidad 0 sin que nadie las observara: en la ficha en vivo las tres
       filas se pintaban enteras —etiqueta y cuatro tarjetas— y no se veía
       ninguna. Un MutationObserver engancha cualquier .vv-reveal nuevo al
       mismo observer de entrada; si no hay observer, se muestra directo. */
    var sinAnimar = reduceMotion || !('IntersectionObserver' in window);
    var io = null;
    if (!sinAnimar) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    function revelar(el) {
      if (el.classList.contains('is-in')) return;
      if (io) io.observe(el); else el.classList.add('is-in');
    }
    $$('.vv-reveal').forEach(revelar);

    if ('MutationObserver' in window) {
      new MutationObserver(function (cambios) {
        cambios.forEach(function (c) {
          for (var i = 0; i < c.addedNodes.length; i++) {
            var n = c.addedNodes[i];
            if (n.nodeType !== 1) continue;
            if (n.classList.contains('vv-reveal')) revelar(n);
            $$('.vv-reveal', n).forEach(revelar);
          }
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  })();

  /* ------------------------------------------------------------------ *
   * Announcement rotator
   * ------------------------------------------------------------------ */
  (function () {
    var rotator = $('[data-vv-rotator]');
    if (!rotator) return;
    var items = $$('[data-vv-rotator-item]', rotator);
    if (items.length < 2) return;
    var i = 0;
    var delay = parseInt(rotator.getAttribute('data-vv-rotator'), 10) || 5000;
    if (reduceMotion) return;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, delay);
  })();

  /* ------------------------------------------------------------------ *
   * Announcement dismiss — remembered for the session only.
   * ------------------------------------------------------------------ */
  (function () {
    var bar = $('[data-vv-announcement]');
    if (!bar) return;
    var key = 'vv-announcement-' + (bar.getAttribute('data-vv-announcement') || '1');
    try { if (sessionStorage.getItem(key) === 'closed') { bar.remove(); return; } } catch (e) {}
    var close = $('[data-vv-announcement-close]', bar);
    if (close) close.addEventListener('click', function () {
      bar.remove();
      try { sessionStorage.setItem(key, 'closed'); } catch (e) {}
    });
  })();

  /* ------------------------------------------------------------------ *
   * Quantity steppers
   * ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vv-qty]');
    if (!btn) return;
    var input = $('input', btn.parentNode);
    if (!input) return;
    var step = btn.getAttribute('data-vv-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.min, 10) || 1;
    var next = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------ *
   * Cart — AJAX add + drawer refresh, with real error surfacing.
   * ------------------------------------------------------------------ */
  var Cart = {
    routes: (window.vvRoutes || {}),

    async add(form, button) {
      var data = new FormData(form);
      button && button.classList.add('is-loading');
      try {
        var res = await fetch((this.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: data
        });
        var json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || 'No se pudo agregar el producto.');
        await this.refresh();
        Drawer.show('vv-cart-drawer');
        document.dispatchEvent(new CustomEvent('vv:cart:added', { detail: json }));
      } catch (err) {
        this.error(form, err.message);
      } finally {
        button && button.classList.remove('is-loading');
      }
    },

    error(form, message) {
      var slot = $('[data-vv-form-error]', form);
      if (slot) { slot.textContent = message; slot.hidden = false; }
      else { console.warn('[vv] cart:', message); }
    },

    async refresh() {
      var res = await fetch((this.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } });
      var cart = await res.json();
      $$('[data-vv-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });
      var drawer = $('#vv-cart-drawer [data-vv-cart-content]');
      if (drawer) {
        var html = await fetch((this.routes.cart || '/cart') + '?view=drawer').then(function (r) { return r.text(); });
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-vv-cart-content]');
        if (next) drawer.innerHTML = next.innerHTML;
      }
      document.dispatchEvent(new CustomEvent('vv:cart:updated', { detail: cart }));
      return cart;
    },

    async change(line, quantity) {
      /* Se lee la línea ANTES de tocarla: después de la petición ya no existe
         y no habría con qué decir qué se quitó. */
      var before = null;
      try {
        var snapshot = await fetch((this.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        before = snapshot.items[parseInt(line, 10) - 1] || null;
      } catch (err) { /* medir nunca puede romper el carrito */ }

      var res = await fetch((this.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      await res.json();

      if (before && quantity < before.quantity) {
        var gone = Object.assign({}, before, { quantity: before.quantity - quantity });
        document.dispatchEvent(new CustomEvent('vv:cart:removed', { detail: gone }));
      }
      return this.refresh();
    }
  };
  window.VVCart = Cart;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-vv-add-form]');
    if (!form) return;
    e.preventDefault();
    var slot = $('[data-vv-form-error]', form);
    if (slot) slot.hidden = true;
    Cart.add(form, $('[data-vv-add-button]', form));
  });

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-vv-cart-remove]');
    if (remove) { e.preventDefault(); Cart.change(remove.getAttribute('data-vv-cart-remove'), 0); }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-vv-cart-qty]');
    if (input) Cart.change(input.getAttribute('data-vv-cart-qty'), parseInt(input.value, 10) || 0);
  });

  /* ------------------------------------------------------------------ *
   * Variant selection — swaps price, availability, media and URL.
   * Works with the store's seven different "Talla - *" option names
   * because it matches by option position, never by option name.
   * ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-vv-option]');
    if (!input) return;
    var root = input.closest('[data-vv-product]');
    if (!root) return;

    var variants = JSON.parse($('[data-vv-variants]', root).textContent);
    var selected = $$('[data-vv-option]', root)
      .filter(function (el) { return el.type !== 'radio' || el.checked; })
      .sort(function (a, b) { return a.getAttribute('data-vv-option') - b.getAttribute('data-vv-option'); })
      .map(function (el) { return el.value; });

    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });

    // Reflect availability on every size chip for the chosen colour.
    $$('[data-vv-option-value]', root).forEach(function (el) {
      var pos = parseInt(el.getAttribute('data-vv-option-pos'), 10);
      var candidate = selected.slice();
      candidate[pos - 1] = el.getAttribute('data-vv-option-value');
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === candidate[i]; }); });
      el.setAttribute('data-available', String(!!(v && v.available)));
    });

    var priceSlot  = $('[data-vv-price]', root);
    var button     = $('[data-vv-add-button]', root);
    var idInput    = $('[data-vv-variant-id]', root);
    var label      = $('[data-vv-option-label="' + input.getAttribute('data-vv-option') + '"]', root);
    if (label) label.textContent = input.value;

    if (!match) {
      if (button) { button.disabled = true; button.textContent = button.getAttribute('data-text-unavailable') || 'No disponible'; }
      return;
    }
    if (idInput) idInput.value = match.id;
    if (priceSlot && match.price_html) priceSlot.innerHTML = match.price_html;
    if (button) {
      button.disabled = !match.available;
      button.textContent = match.available
        ? (button.getAttribute('data-text-add') || 'Agregar')
        : (button.getAttribute('data-text-soldout') || 'Agotado');
    }

    var media = $('[data-vv-media-id="' + match.featured_media_id + '"]', root);
    if (media && media.scrollIntoView) media.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url.toString());
    }

    /* Existencia por sucursal: se relee la sección para la variante elegida.
       No va en el JSON de variantes a propósito —pedirle a Shopify la
       existencia por ubicación de las 40 variantes de una ficha es justo lo
       que la plataforma pide no hacer—, así que se pide sólo la que el
       comprador está mirando.

       Se retrasa un poco y se cancela la petición anterior: quien prueba
       cinco tallas seguidas no debe disparar cinco consultas ni ver llegar la
       respuesta de la talla que ya descartó. */
    actualizarExistencia(root, match.id);
  });

  /* ------------------------------------------------------------------ *
   * Recomendaciones de producto.
   *
   * Esto FALTABA, y el hueco no se veía: la sección tenía su contenedor con
   * la URL puesta, pero nadie la pedía nunca. El bloque de Liquid que hay
   * dentro sólo se pinta cuando la propia petición vino por la ruta de
   * recomendaciones —que en una ficha normal no es el caso—, así que la
   * franja «También te puede gustar» salía VACÍA en las 1,577 fichas, con su
   * etiqueta y sin un solo producto debajo.
   *
   * Se piden al entrar en vista para no gastar red en algo que está a tres
   * pantallas de scroll. Si la respuesta viene sin productos —lo normal en
   * «va con esto» mientras nadie haya enlazado nada en Search & Discovery—
   * la sección entera se retira en vez de dejar un título huérfano.
   * ------------------------------------------------------------------ */
  function montarRec(caja) {
    /* El cajón del carrito se repinta entero al añadir algo, así que sus
       contenedores son nuevos cada vez. La marca evita pedir dos veces lo
       mismo y permite montar los que acaban de aparecer. */
    if (caja.getAttribute('data-vv-rec') === 'listo') return;
    caja.setAttribute('data-vv-rec', 'listo');

    var url = caja.getAttribute('data-url');
    if (!url) return;

    /* Una fila que se queda sin productos se retira sola. Si era la última
       viva de su sección, se lleva la sección entera: un título de «Completa
       el look» sin nada debajo es peor que no tener la franja. */
    function rendirse() {
      var seccion = caja.closest('section');
      caja.remove();
      if (seccion && !seccion.querySelector('[data-vv-list]') &&
          !seccion.querySelector('[data-vv-rec]')) seccion.remove();
    }

    /* Lo que ya está en el carrito no se vuelve a ofrecer. Los handles vienen
       en el marcado porque el servidor los conoce y el navegador no. */
    var excluir = (caja.getAttribute('data-excluir') || '')
      .split(',').filter(Boolean);

    function extraer(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      /* Dos formas de responder: las recomendaciones devuelven la misma
         sección con el mismo id; una rejilla pedida por section_id devuelve
         otra sección distinta. Se busca primero por id y se cae a la rejilla
         suelta. */
      var propia = doc.querySelector('#' + CSS.escape(caja.id));
      var lista = (propia && propia.querySelector('[data-vv-list]')) ||
                  doc.querySelector('[data-vv-list]');
      if (!lista) return null;

      if (excluir.length) {
        $$('[data-vv-card]', lista).forEach(function (card) {
          var h = (card.outerHTML.match(/\/products\/([^"'?#]+)/) || [])[1];
          if (h && excluir.indexOf(h) !== -1) card.remove();
        });
      }
      return lista.querySelector('[data-vv-card], .vv-card') ? lista : null;
    }

    function pintar(lista) {
      var titulo = caja.getAttribute('data-titulo');
      if (titulo) {
        var h = document.createElement('p');
        h.className = 'vv-complook__label vv-label vv-label--sm';
        h.textContent = titulo;
        caja.appendChild(h);
      }
      caja.appendChild(lista);
    }

    function cargar() {
      var alterna = caja.getAttribute('data-url-alt');
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var lista = extraer(html);
          if (lista) { pintar(lista); return; }
          /* Sin complementarios enlazados a mano se cae a los relacionados,
             que Shopify calcula sola. Es peor recomendación, pero es mejor
             que un hueco. */
          if (!alterna) { rendirse(); return; }
          return fetch(alterna)
            .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
            .then(function (html2) {
              var l2 = extraer(html2);
              if (l2) pintar(l2); else rendirse();
            });
        })
        .catch(rendirse);
    }

    if ('IntersectionObserver' in window) {
      /* Se observa algo que TENGA tamaño. Las filas de «Completa el look»
         son divs vacíos de 0 px de alto hasta que se pintan, y sobre un
         elemento sin área el observer no llega a disparar: en la ficha en
         vivo las tres filas quedaban en «listo» sin haber pedido nada —la
         única petición al buscador en toda la red era una hecha a mano—.
         Si la caja no mide, se observa su sección, que sí mide. */
      var vigilado = caja;
      if (!caja.getBoundingClientRect().height) {
        vigilado = caja.closest('section') || caja.parentElement || caja;
      }
      var obs = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        obs.disconnect();
        cargar();
      }, { rootMargin: '600px' });
      obs.observe(vigilado);
    } else {
      cargar();
    }
  }

  $$('[data-vv-rec]').forEach(montarRec);

  /* Y otra vez cada vez que el carrito se repinta: sin esto, la franja «va
     con lo que llevas» del cajón se quedaba muerta después del primer
     añadido, porque su contenedor ya no era el que se montó al cargar. */
  document.addEventListener('vv:cart:updated', function () {
    $$('[data-vv-rec]').forEach(montarRec);
  });

  /* ------------------------------------------------------------------ *
   * VISTOS RECIENTEMENTE, y LA TALLA QUE YA SE SABE.
   *
   * Las dos cosas viven en el navegador de quien mira y en ningún otro
   * sitio. No viajan al servidor, no se cruzan con nadie y no identifican a
   * nadie: son handles de producto y un número de talla. Si el
   * almacenamiento está bloqueado —ventana privada, ajustes del sistema—
   * todo esto se apaga solo y la página funciona igual.
   * ------------------------------------------------------------------ */
  /* «Llévate el conjunto»: las piezas entran en UNA sola petición, no en
     tres seguidas. Con tres peticiones el cajón se abre y se repinta tres
     veces, y si la segunda falla el carrito queda a medias sin que nadie lo
     sepa. /cart/add.js acepta varias líneas de golpe: o entran todas o no
     entra ninguna. */
  $$('[data-vv-conjunto-todo]').forEach(function (boton) {
    boton.addEventListener('click', function () {
      var ids = (boton.getAttribute('data-ids') || '').split(',').filter(Boolean);
      if (!ids.length) return;

      var original = boton.textContent;
      boton.disabled = true;

      fetch(window.vvRoutes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
        })
      })
        .then(function (r) { return r.json().then(function (j) { return r.ok ? j : Promise.reject(j); }); })
        .then(function (json) {
          Cart.refresh();
          Drawer.show('vv-cart-drawer');
          document.dispatchEvent(new CustomEvent('vv:cart:added', { detail: json }));
        })
        .catch(function (err) {
          boton.textContent = (err && err.description) || 'No se pudo agregar';
          setTimeout(function () { boton.textContent = original; }, 2600);
        })
        .then(function () { boton.disabled = false; });
    });
  });

  var Memoria = {
    leer: function (clave, porDefecto) {
      try {
        var v = localStorage.getItem(clave);
        return v ? JSON.parse(v) : porDefecto;
      } catch (e) { return porDefecto; }
    },
    escribir: function (clave, valor) {
      try { localStorage.setItem(clave, JSON.stringify(valor)); } catch (e) {}
    },
    borrar: function (clave) {
      try { localStorage.removeItem(clave); } catch (e) {}
    }
  };

  /* Anotar la ficha que se está viendo. Se guarda el handle y nada más: el
     precio y el nombre se vuelven a pedir al servidor, así que un precio
     recordado no puede quedarse viejo. */
  var fichaActual = document.querySelector('[data-vv-product]');
  if (fichaActual) {
    var handleActual = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (handleActual) {
      var vistos = Memoria.leer('vv-vistos', []).filter(function (h) { return h !== handleActual; });
      vistos.unshift(handleActual);
      Memoria.escribir('vv-vistos', vistos.slice(0, 12));
    }
  }

  var franjaVistos = $('[data-vv-vistos]');
  if (franjaVistos) {
    var lista = $('[data-vv-vistos-lista]', franjaVistos);
    var limite = parseInt(franjaVistos.getAttribute('data-limite'), 10) || 4;
    var handles = Memoria.leer('vv-vistos', [])
      .filter(function (h) { return h !== (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1]; })
      .slice(0, limite);

    if (handles.length) {
      /* Se piden todos a la vez y se pintan EN ORDEN, no según cuál conteste
         antes: «lo que estabas viendo» sin el orden en que lo viste no
         significa nada. */
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?view=card')
          .then(function (r) { return r.ok ? r.text() : null; })
          .catch(function () { return null; });
      })).then(function (piezas) {
        var puestas = 0;
        piezas.forEach(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-vv-card]') || doc.querySelector('.vv-card');
          if (!card) return;
          lista.appendChild(card);
          puestas++;
        });
        if (puestas) franjaVistos.hidden = false;
      });
    }

    var olvidar = $('[data-vv-vistos-olvidar]', franjaVistos);
    if (olvidar) olvidar.addEventListener('click', function () {
      Memoria.borrar('vv-vistos');
      franjaVistos.hidden = true;
    });
  }

  /* La talla que ya se sabe. Se anota cuando alguien AÑADE AL CARRITO, no
     cuando toca una talla: tocar es mirar, añadir es decidir. Y se guarda
     por familia de prenda, porque nadie calza lo mismo de bota que de
     camisa. */
  document.addEventListener('vv:cart:added', function (e) {
    var i = e.detail || {};
    var talla = null;
    (i.options_with_values || []).forEach(function (o) {
      if (/talla|size/i.test(o.name || '')) talla = o.value;
    });
    if (!talla) return;
    var familia = (i.product_type || 'otro').toLowerCase().replace(/[^a-z]/g, '').slice(0, 8) || 'otro';
    var tallas = Memoria.leer('vv-tallas', {});
    tallas[familia] = talla;
    Memoria.escribir('vv-tallas', tallas);
  });

  /* Y se usa: en la ficha, si esa talla existe y está disponible, se
     preselecciona y se dice por qué. Nunca se selecciona una talla agotada
     ni se oculta ninguna: la decisión sigue siendo del comprador, esto sólo
     le ahorra el clic que ya hizo la vez pasada. */
  if (fichaActual) {
    var tallasSabidas = Memoria.leer('vv-tallas', {});
    var tipoFicha = (fichaActual.getAttribute('data-tipo') || '').toLowerCase().replace(/[^a-z]/g, '').slice(0, 8);
    var sugerida = tallasSabidas[tipoFicha];
    if (sugerida) {
      var chip = $$('[data-vv-option-value]', fichaActual).find(function (c) {
        return c.getAttribute('data-vv-option-value') === sugerida &&
               c.getAttribute('data-available') === 'true';
      });
      if (chip) {
        var radio = document.getElementById(chip.getAttribute('for'));
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var nota = $('[data-vv-talla-nota]', fichaActual);
        if (nota) { nota.textContent = nota.getAttribute('data-plantilla').replace('%s', sugerida); nota.hidden = false; }
      }
    }
  }

  var pendienteStock = null;
  var abortoStock = null;
  function actualizarExistencia(root, variantId) {
    var caja = $('[data-vv-stock]', root);
    if (!caja || !caja.getAttribute('data-url')) return;

    clearTimeout(pendienteStock);
    pendienteStock = setTimeout(function () {
      if (abortoStock) abortoStock.abort();
      abortoStock = new AbortController();

      var url = caja.getAttribute('data-url') + '&variant=' + encodeURIComponent(variantId);
      caja.setAttribute('aria-busy', 'true');

      fetch(url, { signal: abortoStock.signal })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nueva = doc.querySelector('[data-vv-stock]');
          /* Si la respuesta no trae el bloque, se deja lo que había: una caja
             vacía diría «no hay en ninguna» y eso sería mentira. */
          if (nueva) caja.innerHTML = nueva.innerHTML;
        })
        .catch(function () { /* red caída o petición cancelada: no se toca */ })
        .then(function () { caja.removeAttribute('aria-busy'); });
    }, 250);
  }

  /* ------------------------------------------------------------------ *
   * Marquee — duplicate the track so the loop is seamless.
   * ------------------------------------------------------------------ */
  $$('[data-vv-marquee]').forEach(function (track) {
    if (reduceMotion) return;
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  /* ------------------------------------------------------------------ *
   * Mobile buy bar.
   *
   * Appears once the real add-to-cart form scrolls out of view. It never
   * holds its own variant state: it submits the page's one form, so the
  /* ------------------------------------------------------------------ *
   * Árbitro del borde inferior.
   *
   * Cuatro cosas distintas quieren el mismo centímetro de pantalla en un
   * teléfono: la barra del pulgar, la barra de compra de la ficha, el
   * recordatorio de la ruleta y el «guardar como app». Cada una se construyó
   * sabiendo de sí misma y de ninguna otra, así que en una ficha de producto
   * con la ruleta ganada y Chrome ofreciendo instalar, se apilaban tres
   * franjas sobre la única acción que importa.
   *
   * La regla es de negocio, no de diseño: NADA le gana a comprar. Después la
   * promoción que el comprador ya se ganó. Al final, la conveniencia.
   *
   * Sólo se pinta la de mayor prioridad que esté pidiendo turno. Las demás no
   * se destruyen: esperan, y aparecen solas en cuanto la de arriba se va.
   * ------------------------------------------------------------------ */
  var Layers = (function () {
    var slots = [];   // { name, el, priority, wants }

    function register(name, el, priority) {
      if (!el) return;
      slots.push({ name: name, el: el, priority: priority, wants: false });
      slots.sort(function (a, b) { return b.priority - a.priority; });
    }

    // Una toma de pantalla completa —la ruleta, un cajón— silencia el borde
    // entero: dos interrupciones a la vez no son urgencia, son ruido.
    function blocked() {
      return document.body.classList.contains('vv-locked') ||
             !!document.querySelector('.vv-wheel.is-open');
    }

    function apply() {
      var winner = null;
      if (!blocked()) {
        for (var i = 0; i < slots.length; i++) {
          if (slots[i].wants) { winner = slots[i]; break; }
        }
      }
      slots.forEach(function (s) {
        var on = s === winner;
        if (on) s.el.hidden = false;
        s.el.classList.toggle('is-in', on);
        s.el.setAttribute('aria-hidden', String(!on));
      });
    }

    return {
      register: register,
      request: function (name) { set(name, true); },
      release: function (name) { set(name, false); },
      refresh: apply
    };

    function set(name, wants) {
      slots.forEach(function (s) { if (s.name === name) s.wants = wants; });
      apply();
    }
  })();
  window.VVLayers = Layers;

  // Abrir o cerrar un cajón cambia quién manda en el borde.
  document.addEventListener('vv:drawer:open', Layers.refresh);
  document.addEventListener('vv:drawer:close', Layers.refresh);

  /* ------------------------------------------------------------------ *
   * Barra de compra en móvil.
   *
   * Aparece cuando el formulario real sale de vista. Nunca guarda su propio
   * estado de variante: envía el mismo formulario de la página, así que la
   * talla y el color elegidos no pueden separarse de lo que se compra.
   * ------------------------------------------------------------------ */
  (function () {
    var bar = $('[data-vv-buybar]');
    var form = $('[data-vv-add-form]');
    if (!bar || !form) return;

    var realButton = $('[data-vv-add-button]', form);
    var barButton = $('[data-vv-buybar-add]', bar);
    var barLabel = $('[data-vv-buybar-label]', bar);

    if (barButton && realButton) {
      barButton.addEventListener('click', function () {
        form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    /* Mirror availability from the real button, which the variant selector
       already keeps correct. */
    function mirror() {
      if (!realButton || !barButton) return;
      barButton.disabled = realButton.disabled;
      if (barLabel) barLabel.textContent = realButton.textContent.trim();
    }
    if (realButton && 'MutationObserver' in window) {
      new MutationObserver(mirror).observe(realButton, { attributes: true, childList: true, subtree: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target.closest('[data-vv-option]')) setTimeout(mirror, 0);
    });

    Layers.register('buybar', bar, 30);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (show) Layers.request('buybar'); else Layers.release('buybar');
        });
      }, { threshold: 0 });
      io.observe(form);
    }
    mirror();
  })();

  /* ------------------------------------------------------------------ *
   * Ruleta — spin to win.
   *
   * Honest about what it is: the countdown is real pressure for the shopper
   * (it survives reloads and the prize is dropped when it ends) but the
   * discount code itself lives in Shopify and stays valid until its own end
   * date. This code cannot expire a code. See vv-wheel.liquid.
   * ------------------------------------------------------------------ */
  (function () {
    var root = $('[data-vv-wheel]');
    var dataEl = $('[data-vv-wheel-prizes]');
    if (!root || !dataEl) return;

    var prizes;
    try { prizes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!prizes.length) return;

    var DELAY = (parseInt(root.dataset.delay, 10) || 12) * 1000;
    var FREQ = parseInt(root.dataset.frequency, 10);
    var MINUTES = parseInt(root.dataset.minutes, 10) || 30;
    var COOLDOWN = (parseInt(root.dataset.cooldown, 10) || 7) * 86400000;

    var K_PRIZE = 'vv-wheel-prize';
    var K_SEEN = 'vv-wheel-seen';
    var bar = $('[data-vv-wheel-bar]');
    var timerId = null;

    function read(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } }
    function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
    function drop(k) { try { localStorage.removeItem(k); } catch (e) {} }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var held = read(K_PRIZE);
      if (!held) { stop(); return; }
      var left = held.expires - Date.now();
      if (left <= 0) { expire(); return; }
      var mm = Math.floor(left / 60000), ss = Math.floor((left % 60000) / 1000);
      var text = pad(mm) + ':' + pad(ss);
      var t = $('[data-vv-wheel-timer] span'); if (t) t.textContent = text;
      var bt = $('[data-vv-wheel-bar-time]'); if (bt) bt.textContent = text;
    }

    function stop() { if (timerId) { clearInterval(timerId); timerId = null; } }

    function expire() {
      stop(); drop(K_PRIZE);
      if (bar) { Layers.release('wheelbar'); bar.hidden = true; }
      var t = $('[data-vv-wheel-timer]');
      if (t) { t.setAttribute('data-expired', 'true'); var sp = $('span', t); if (sp) sp.textContent = window.vvStrings.wheelExpired || '00:00'; }
    }

    Layers.register('wheelbar', bar, 20);

    function showBar(held) {
      if (!bar) return;
      var c = $('[data-vv-wheel-bar-code]', bar);
      if (c) c.textContent = held.code;
      Layers.request('wheelbar');
    }

    function startCountdown(held) {
      stop();
      tick();
      timerId = setInterval(tick, 1000);
      showBar(held);
    }

    function open() {
      if (document.body.classList.contains('vv-locked')) return false;
      root.hidden = false;
      requestAnimationFrame(function () { root.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      document.body.classList.add('vv-locked');
      if (window.VVLayers) window.VVLayers.refresh();
      return true;
    }
    function close() {
      root.classList.remove('is-open');
      document.body.style.overflow = '';
      document.body.classList.remove('vv-locked');
      setTimeout(function () { root.hidden = true; }, 300);
      if (window.VVLayers) window.VVLayers.refresh();
    }

    /* Weighted pick. Weight 0 means "never", which is useful for turning a
       prize off without deleting the block. */
    function pick() {
      var total = prizes.reduce(function (a, p) { return a + (p.weight || 0); }, 0);
      if (total <= 0) return 0;
      var roll = Math.random() * total, acc = 0;
      for (var i = 0; i < prizes.length; i++) {
        acc += prizes[i].weight || 0;
        if (roll < acc) return i;
      }
      return prizes.length - 1;
    }

    function reveal(i) {
      var p = prizes[i];
      $('[data-vv-wheel-step="spin"]').hidden = true;
      var res = $('[data-vv-wheel-step="result"]');
      res.classList.add('is-shown');
      /* The screen itself carries the outcome: señal for a win, ink for
         nothing. No badge needed — the colour says it before the words. */
      root.setAttribute('data-outcome', p.win ? 'won' : 'lost');
      var foot = $('.vv-wheel__foot');
      if (foot) foot.hidden = true;

      $('[data-vv-wheel-kicker]').textContent = p.win
        ? (window.vvStrings.wheelWon || '')
        : (window.vvStrings.wheelLost || '');
      $('[data-vv-wheel-prize]').textContent = p.prize;
      $('[data-vv-wheel-message]').textContent = p.message || '';

      var won = $('[data-vv-wheel-won]');
      if (p.win && p.code) {
        $('[data-vv-wheel-code]').textContent = p.code;
        won.hidden = false;
        var held = { code: p.code, prize: p.prize, expires: Date.now() + MINUTES * 60000 };
        write(K_PRIZE, held);
        startCountdown(held);
      } else {
        won.hidden = true;
      }
    }

    var spinning = false;
    function spin() {
      if (spinning) return;
      spinning = true;

      var i = pick();
      var track = $('[data-vv-reel]');
      if (!track) { reveal(i); return; }

      var items = $$('.vv-reel__item', track);
      if (!items.length) { reveal(i); return; }

      /* Stop on a late copy of the strip so the run is long whatever the
         number of prizes. Land the chosen item centred under the marker. */
      var perPass = prizes.length;
      var passes = Math.floor(items.length / perPass);
      var landing = Math.max(0, passes - 3) * perPass + i;
      var el = items[landing] || items[i];

      var viewport = track.parentElement.clientWidth;
      var offset = el.offsetLeft + el.offsetWidth / 2 - viewport / 2;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + -offset + 'px)';
        reveal(i);
        return;
      }

      track.style.transform = 'translateX(' + -offset + 'px)';
      /* A beat once it settles, so the run reads as resolved rather than cut. */
      setTimeout(function () { reveal(i); }, 5900);
    }

    /* --------------------------------------------------------------------
     * El correo es el precio de la entrada, no un extra.
     *
     * Sin esto la ruleta regala entre 3% y 10% de margen y no se lleva nada:
     * un descuento plano haría lo mismo con una décima parte del código. El
     * juego es lo que hace que alguien suelte su dirección.
     *
     * Se manda al mismo sitio que el boletín del pie —POST a /contact con
     * form_type=customer—, que es el camino nativo de Shopify: entra a
     * Clientes como suscriptor, sin app de por medio. Va sin esperar
     * respuesta a propósito: si Shopify tarda, la ruleta gira igual. Perder
     * un correo es malo; dejar a alguien mirando un botón muerto es peor.
     * ------------------------------------------------------------------ */
    function conCorreo(seguir) {
      var campo = $('[data-vv-wheel-email]');
      var aviso = $('[data-vv-wheel-email-error]');
      if (!campo) { seguir(); return; }

      var correo = (campo.value || '').trim();
      var valido = correo.length > 4 && correo.indexOf('@') > 0 && correo.lastIndexOf('.') > correo.indexOf('@');
      if (!valido) {
        if (aviso) aviso.hidden = false;
        campo.setAttribute('aria-invalid', 'true');
        campo.focus();
        return;
      }
      if (aviso) aviso.hidden = true;
      campo.removeAttribute('aria-invalid');

      try {
        var datos = new FormData();
        datos.append('form_type', 'customer');
        datos.append('utf8', '\u2713');
        datos.append('contact[email]', correo);
        datos.append('contact[tags]', 'newsletter,ruleta');
        fetch('/contact', { method: 'POST', body: datos }).catch(function () {});
      } catch (err) {}

      seguir();
    }

    root.addEventListener('click', function (e) {
      if (e.target === root || e.target.closest('[data-vv-wheel-close]')) { close(); return; }
      if (e.target.closest('[data-vv-wheel-spin]')) { conCorreo(spin); return; }
      var copyBtn = e.target.closest('[data-vv-wheel-copy]');
      if (copyBtn) {
        var code = $('[data-vv-wheel-code]').textContent;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = window.vvStrings.wheelCopied || 'OK';
          }).catch(function () {});
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    /* ---- decide whether this visitor ever sees it -------------------- */
    var held = read(K_PRIZE);
    if (held && held.expires > Date.now()) { startCountdown(held); return; }
    if (held) drop(K_PRIZE);

    var seen = read(K_SEEN);
    if (seen && Date.now() - seen.at < COOLDOWN) return;

    /* One honest roll, remembered — so the same person is not asked twice. */
    var qualifies = Math.random() * 100 < (isNaN(FREQ) ? 35 : FREQ);
    write(K_SEEN, { at: Date.now(), q: qualifies });
    if (!qualifies) return;

    /* La tirada de este visitante ya se gastó arriba, así que si el momento
       llega con el carrito abierto NO se puede perder: espera a que se cierre
       y entra entonces. Una sola vez — si sigue navegando en cajones, se deja
       en paz. */
    setTimeout(function () {
      if (open() !== false) return;
      document.addEventListener('vv:drawer:close', function once() {
        document.removeEventListener('vv:drawer:close', once);
        setTimeout(open, 900);
      });
    }, DELAY);
  })();

  /* ------------------------------------------------------------------ *
   * Save to home screen.
   *
   * Two different worlds behind one affordance:
   *   Chrome  — `beforeinstallprompt` gives us a real install dialog.
   *   iOS     — no programmatic prompt exists, ever. We show instructions.
   *
   * The bar only appears if it can do something useful, never on the first
   * paint, and never again once dismissed.
   * ------------------------------------------------------------------ */
  (function () {
    var bar = $('[data-vv-install]');
    if (!bar) return;

    var KEY = 'vv-install-dismissed';
    var deferred = null;

    function dismissed() {
      try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
    }
    function remember() {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    }

    // Already installed: standalone display, or iOS's own flag.
    var standalone = window.matchMedia('(display-mode: standalone)').matches ||
                     window.navigator.standalone === true;
    if (standalone || dismissed()) return;

    var ua = window.navigator.userAgent;
    var isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    var isSafari = isIOS && /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);

    function reveal(mode) {
      var cta = $('[data-vv-install-accept]', bar);
      var sub = $('[data-vv-install-sub]', bar);
      if (mode === 'ios') {
        // No button can install on iOS. Offering one would be a lie.
        if (cta) cta.hidden = true;
        if (sub && window.vvStrings && window.vvStrings.pwaIos) sub.textContent = window.vvStrings.pwaIos;
      }
      Layers.request('install');
    }
    Layers.register('install', bar, 10);

    /* CUÁNDO APARECE. Antes, en Chrome, salía en cuanto el navegador
       ofrecía instalar: o sea, de inmediato. Y como es una barra fija abajo,
       tapaba los botones de la portada —que en un teléfono están justo ahí—.
       Se vio en la maqueta: la barra encima del botón principal del sitio.

       Ahora espera a que la persona haya bajado una pantalla, o a que pasen
       unos segundos. Quien no ha mirado nada todavía tampoco tiene por qué
       querer instalarse la tienda. iOS ya lo hacía así; Chrome no, y no había
       razón para que fueran distintos. */
    function cuandoToque(fn) {
      var hecho = false;
      function lanzar() {
        if (hecho) return;
        hecho = true;
        window.removeEventListener('scroll', alBajar);
        fn();
      }
      function alBajar() { if (window.scrollY > window.innerHeight * 0.8) lanzar(); }
      window.addEventListener('scroll', alBajar, { passive: true });
      setTimeout(lanzar, 8000);
      alBajar();
    }

    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      deferred = e;
      cuandoToque(function () { reveal('prompt'); });
    });

    // iOS never fires the event, so it is revealed on the same terms.
    if (isSafari) cuandoToque(function () { if (!bar.classList.contains('is-in')) reveal('ios'); });

    bar.addEventListener('click', function (e) {
      if (e.target.closest('[data-vv-install-dismiss]')) {
        Layers.release('install');
        remember();
        setTimeout(function () { bar.hidden = true; }, 260);
        return;
      }
      if (e.target.closest('[data-vv-install-accept]') && deferred) {
        deferred.prompt();
        deferred.userChoice.then(function () {
          deferred = null;
          Layers.release('install');
          remember();
          setTimeout(function () { bar.hidden = true; }, 260);
        });
      }
    });

    window.addEventListener('appinstalled', function () {
      remember();
      Layers.release('install');
      setTimeout(function () { bar.hidden = true; }, 260);
    });
  })();


  /* ------------------------------------------------------------------ *
   * List position tracking.
   *
   * The benchmark's finding was not that we lack analytics — it is that
   * every product click looks identical in the data. Without a list name
   * and a position, there is no way to answer "does the third row of the
   * home page earn its place" or "do people click past the first screen
   * of a collection", which are the two questions merchandising actually
   * asks. Shopify's own analytics never captures this.
   *
   * Nothing is annotated per card: a surface declares [data-vv-list] and
   * the position is read from the DOM at click time.
   *
   * This pushes to window.dataLayer, which is the neutral format GTM,
   * GA4 and a server-side tag can all read. If no dataLayer exists the
   * array is created and simply never consumed — no error, no network.
   * ------------------------------------------------------------------ */
  (function () {
    window.dataLayer = window.dataLayer || [];

    function positionIn(list, el) {
      var items = $('.vv-card, li', list);
      for (var i = 0; i < items.length; i++) {
        if (items[i].contains(el)) return i + 1;
      }
      return 0;
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href], button[data-vv-position]');
      if (!link) return;

      var list = link.closest('[data-vv-list]');
      var listName = list ? list.getAttribute('data-vv-list') : link.getAttribute('data-vv-position');
      if (!listName) return;

      var card = link.closest('.vv-card, .vv-upsell__item, li');
      var title = card ? (card.querySelector('.vv-card__title, .vv-upsell__title') || {}).textContent : link.textContent;

      /* Forma GA4: el nombre de la lista y la posición viven en el evento,
         el producto dentro de items[]. Así lo lee GA4 sin traducción. */
      window.dataLayer.push({
        event: 'select_item',
        item_list_name: listName,
        items: [{
          item_name: (title || '').trim().slice(0, 120),
          index: list ? positionIn(list, link) : 0,
          link_url: link.getAttribute('href') || ''
        }]
      });
    }, true);
  })();


  /* ------------------------------------------------------------------ *
   * Video de fondo — el corte correcto, y sólo uno.
   *
   * El <video> llega vacío del servidor a propósito: hasta que este código
   * corre, el navegador no ha pedido un solo byte de video. Aquí se decide
   * cuál de los dos cortes corresponde al ancho real de la pantalla y se pide
   * ése. Un teléfono nunca descarga la pieza de escritorio.
   *
   * Y hay dos casos en los que no se pide ninguno: «reducir movimiento» y
   * ahorro de datos. Los dos son una decisión explícita del visitante, así que
   * se queda el póster —que es una toma de la campaña, no un marcador gris—.
   * ------------------------------------------------------------------ */
  (function () {
    var videos = $$('[data-vv-video]');
    if (!videos.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var conn = navigator.connection || {};
    if (reduced || conn.saveData) return;

    var wide = window.matchMedia('(min-width: 750px)');

    function load(v) {
      var src = wide.matches ? v.getAttribute('data-src-wide') : v.getAttribute('data-src-tall');

      /* Sin pieza para este ancho no se pide nada y se deja el póster a la
         vista. Es el caso real de esta marca: filman en vertical, así que en
         escritorio manda la fotografía. */
      if (!src) { v.classList.remove('is-ready'); return; }
      if (v.getAttribute('data-loaded') === src) return;
      v.setAttribute('data-loaded', src);
      v.innerHTML = '';
      var source = document.createElement('source');
      source.src = src;
      source.type = 'video/mp4';
      v.appendChild(source);
      v.load();
      var play = v.play();
      if (play && play.catch) play.catch(function () { /* autoplay denegado: se queda el póster */ });
      v.addEventListener('playing', function () { v.classList.add('is-ready'); }, { once: true });
    }

    /* Un hero fuera de pantalla no tiene por qué gastar datos. */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { load(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '200px' });
      videos.forEach(function (v) { io.observe(v); });
    } else {
      videos.forEach(load);
    }

    /* Girar el teléfono cambia cuál es el corte correcto. */
    var onChange = function () { videos.forEach(load); };
    if (wide.addEventListener) wide.addEventListener('change', onChange);
    else if (wide.addListener) wide.addListener(onChange);
  })();

  /* ------------------------------------------------------------------ *
   * CLIPS DE LA FRANJA SOCIAL — se cargan al llegar, se pausan al irse.
   *
   * Salen del servidor con preload="none" y sin autoplay, así que abrir la
   * portada no descarga ni un byte de video. Cuando la franja se acerca a
   * 300 px de la pantalla se les pone preload="auto" y se arrancan; cuando
   * se van, se pausan. Cinco clips de ~3 MB son ~15 MB: se pagan sólo si
   * alguien llega hasta ahí, y nunca los cinco al abrir.
   *
   * Con «reducir movimiento» o con ahorro de datos activado no se cargan:
   * se queda el póster, igual que hace vv-bgvideo con el hero.
   * ------------------------------------------------------------------ */
  (function () {
    var clips = $$('[data-vv-lazyclip] video');
    if (!clips.length) return;
    var conn = navigator.connection || {};
    if (reduceMotion || conn.saveData) return;

    function arranca(v) {
      if (v.getAttribute('preload') !== 'auto') v.setAttribute('preload', 'auto');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function para(v) { if (!v.paused) v.pause(); }

    if (!('IntersectionObserver' in window)) { clips.forEach(arranca); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) arranca(e.target); else para(e.target);
      });
    }, { rootMargin: '300px 0px' });
    clips.forEach(function (v) { io.observe(v); });
  })();

})();
